import { useState } from 'react';
import { Table } from '@humanforce/mango-ui-react';
import { HOLIDAYS, REGION_INFO } from '../organisationFixtures';
import type { OrgData } from '../organisationFixtures';

interface PublicHolidaysTabProps {
  orgId: string;
  orgData: OrgData;
}

interface HolidayRow {
  date: string;
  name: string;
}

const columns = [
  { field: 'date', header: 'Date', sortable: true },
  { field: 'name', header: 'Holiday name', sortable: true },
];

export const PublicHolidaysTab = ({ orgData }: PublicHolidaysTabProps) => {
  const [selectedByCountry, setSelectedByCountry] = useState<Record<string, HolidayRow[]>>({});

  const countries = [
    ...new Set(
      orgData.businessRecords
        .flatMap((br) => br.payrolls)
        .map((p) => REGION_INFO[p.region]?.country)
        .filter((c): c is string => Boolean(c))
    ),
  ];

  return (
    <div className="mgo-stack mgo-gap-xl">
      {countries.map((country) => {
        const holidays = HOLIDAYS[country] ?? [];
        const rows: HolidayRow[] = holidays.map((h) => ({ date: h.date, name: h.name }));
        return (
          <div key={country}>
            <h2 className="mgo-text-l mgo-weight-strong" style={{ marginBottom: 'var(--mgo-space-30)' }}>
              {country}
            </h2>
            <Table
              value={rows}
              columns={columns}
              selectable
              selection={selectedByCountry[country] ?? []}
              onSelectionChange={(sel) => setSelectedByCountry((current) => ({
                ...current,
                [country]: Array.isArray(sel) ? sel as HolidayRow[] : [sel as HolidayRow],
              }))}
            />
          </div>
        );
      })}
    </div>
  );
};
